import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  // Font Awesome icons
  icons: { iconfont: "fa" },
  theme: {
    themes: {
      light: {
        primary: "#00303c",
        secondary: "#aa6923",
      },
      dark: {
        primary: "#00303c",
        secondary: "#aa6923",
      }
    }
  }
});
